const PROD_API_BASE = 'https://api.inboxops.ai';

function cleanBase(value) {
  if (value == null) return null;

  const base = String(value).trim();
  if (!base) return null;
  if (base === '/' || base.toLowerCase() === 'relative') return '';

  return base.replace(/\/+$/, '');
}

function runtimeValue() {
  const w = typeof window !== 'undefined' ? window : undefined;

  return (
    w?.__INBOXOPS__?.BACKEND_URL ||
    w?.__INBOXOPS_CONFIG__?.BACKEND_URL ||
    w?.__ENV__?.BACKEND_URL ||
    w?.__ENV__?.REACT_APP_BACKEND_URL ||
    w?.__ENV__?.API_URL ||
    null
  );
}

function envValue() {
  try {
    return (
      process.env.REACT_APP_BACKEND_URL ||
      process.env.REACT_APP_API_BASE_URL ||
      process.env.REACT_APP_API_BASE ||
      process.env.REACT_APP_API_URL ||
      process.env.VITE_BACKEND_URL ||
      null
    );
  } catch {
    return null;
  }
}

function isLocalHost(hostname) {
  return (
    !hostname ||
    hostname === 'localhost' ||
    hostname === '::1' ||
    hostname.startsWith('127.')
  );
}

export function getApiBase() {
  const explicit = cleanBase(runtimeValue() || envValue());
  if (explicit != null) return explicit;

  const w = typeof window !== 'undefined' ? window : undefined;
  const protocol = w?.location?.protocol || 'http:';
  const hostname =
    w?.location?.hostname ||
    '';

  if (isLocalHost(hostname)) {
    const host = hostname === '::1' ? 'localhost' : hostname || 'localhost';
    return `${protocol}//${host}:3000`;
  }

  return PROD_API_BASE;
}

export function getBackendNavigationBase() {
  const explicit = cleanBase(runtimeValue() || envValue());
  if (explicit != null && explicit !== '') return explicit;

  const w = typeof window !== 'undefined' ? window : undefined;
  const protocol = w?.location?.protocol || 'http:';
  const hostname = w?.location?.hostname || 'localhost';

  if (isLocalHost(hostname)) {
    const host = hostname === '::1' ? 'localhost' : hostname || 'localhost';
    return `${protocol}//${host}:3000`;
  }

  return PROD_API_BASE;
}
